var path = '/app/webpack/wealthbar/components/search_box/search_box.html.slim';
var html = "<div class=\"search-box\"><input ng-model=\"searchCtrl.searchQuery\" placeholder=\"Search...\" type=\"text\" /></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;